import {
  FAILED_PATCH_USER_INFO,
  GET_USER_INFO,
  PASSWORD_VALIDATION,
  PATCHING_USER_INFO,
  SUCCESS_PATCH_USER_INFO,
  SUCCESS_PATCH_USER_PASSWORD,
  UPDATE_CAPABILITY,
  UPDATE_DEFAULT_WORKSPACE,
  UPDATE_DELETION_PENDING,
  UPDATE_USER_ERROR,
  UPDATE_USER_INFO,
  UPDATE_USER_NOT_LOGGED_IN,
} from '../constants/actions';

export const getUserInfo = () => {
  return { type: GET_USER_INFO };
};

export const updateUserInfo = user => {
  return {
    type: UPDATE_USER_INFO,
    user,
  };
};

export const updateUserNotLoggedIn = user => {
  return {
    type: UPDATE_USER_NOT_LOGGED_IN,
    user,
  };
};

export const updateUserError = err => {
  return {
    type: UPDATE_USER_ERROR,
    err,
  };
};

export const patchingUserInfo = () => {
  return { type: PATCHING_USER_INFO };
};

export const successPatchUserInfo = () => {
  return { type: SUCCESS_PATCH_USER_INFO };
};

export const failedPatchUserInfo = () => {
  return { type: FAILED_PATCH_USER_INFO };
};

export const successPatchUserPassword = () => {
  return { type: SUCCESS_PATCH_USER_PASSWORD };
};

export const passwordValidation = valid => {
  return {
    type: PASSWORD_VALIDATION,
    valid,
  };
};

export const updateCapability = (capability, isCapable) => {
  return { type: UPDATE_CAPABILITY, capability, isCapable };
};

export const updateDefaultWorkspace = workspaceId => {
  return { type: UPDATE_DEFAULT_WORKSPACE, workspaceId };
};

export const updateDeletionPending = deletionPending => {
  return { type: UPDATE_DELETION_PENDING, deletionPending };
};
